import { render, staticRenderFns } from "./SalesManagement.vue?vue&type=template&id=8a561d46&scoped=true&"
import script from "./SalesManagement.vue?vue&type=script&lang=js&"
export * from "./SalesManagement.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/SalesManagement/SalesManagementList/SalesManagementStyle.css?vue&type=style&index=0&id=8a561d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a561d46",
  null
  
)

export default component.exports